module.exports = __webpack_public_path__ + "static/media/step-8.56d9602c.svg";